import { render, staticRenderFns } from "./teacherCardType.vue?vue&type=template&id=a314bd42&scoped=true&"
import script from "./teacherCardType.vue?vue&type=script&lang=js&"
export * from "./teacherCardType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a314bd42",
  null
  
)

export default component.exports